<!-- 后台管理菜单 组件 -->
<template>
  <div class="appList">
    <!-- 
      defaultValue 默认选中 效果
      expanded // 默认展开菜单
      collapsed 收起不收起
      -->
    <!-- <div v-for="itemM in menulist" :key="itemM.menuId">
      <h3>{{itemM.menuName}}</h3> -->
    <t-menu
      theme="light"
      :defaultValue="routethen"
      :collapsed="collapsed"
      @change="menuchange"
    >
      <template v-for="itemM in menulist" :key="itemM.menuId">
        <h3 v-show="!collapsed">{{ itemM.menuName }}</h3>
        <template v-for="item in itemM.children" :key="item.component">
          <!-- 一级菜单 -->
          <t-menu-item
            :value="item.component"
            v-if="!item.children"
            :to="item.path"
          >
            <template #icon>
              <i class="iconfont ri" :class="item.icon" />
            </template>
            {{ item.menuName }}
          </t-menu-item>
          <!-- 二级菜单 -->
          <t-submenu :title="item.menuName" :value="item.component" v-else>
            <template #icon>
              <i class="iconfont ri" :class="item.icon" />
            </template>
            <t-menu-item
              v-for="sonmenu in item.children"
              :key="sonmenu.component"
              :value="sonmenu.component"
              :to="sonmenu.path"
              >{{ sonmenu.menuName }}</t-menu-item
            >
          </t-submenu>
        </template>
      </template>
      <Empty
        v-if="menulist.length == 0"
        :imgRequire="require('@/assets/Frame113160.png')"
        height="100%"
        >暂无权限</Empty
      >
    </t-menu>
    <!-- </div> -->
    <!-- <t-menu theme="light" :defaultValue="routethen" :collapsed="collapsed" @change="menuchange">
      <template v-for="item in menulist" :key="item.component"> -->
    <!-- 一级菜单 -->
    <!-- <t-menu-item :value="item.component" v-if="item.children.length < 1" :to="item.path">
          <template #icon>
            <icon name="precise-monitor" />
          </template>
          {{ item.menuName }}
        </t-menu-item> -->
    <!-- 二级菜单 -->
    <!-- <t-submenu :title="item.menuName" :value="item.component" v-else>
          <template #icon>
            <icon name="mail" />
          </template>
          <t-menu-item v-for="sonmenu in item.children" :key="sonmenu.component" :value="sonmenu.component"
            :to="sonmenu.path">{{
            sonmenu.menuName }}</t-menu-item>
        </t-submenu> -->
    <!-- </template>
      <Empty v-if="menulist.length == 0" :imgRequire="require('@/assets/Frame113160.png')"  height="90vh">暂无权限</Empty>
    </t-menu> -->

    <div class="sq" @click.native="changecollapsed">
      <t-icon v-show="collapsed" name="chevron-right" size="16" />
      <t-icon v-show="!collapsed" name="chevron-left" size="16" />
    </div>
  </div>
</template>

<script lang="jsx" setup>
import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
  watch,
  computed,
  defineEmits,
} from "vue";
const { $eventBus } = getCurrentInstance().appContext.config.globalProperties;
import { resetSetItem } from "@/utils/Session.js";
import { getRoleMenuByUserId } from "@/api/limitsOfAuthority.js";
import { useRoute } from "vue-router";
import { debounce } from "lodash";
import Empty from "@/components/home/empty/empty";
import Cookies from "js-cookie";

const userInfo = Cookies.get("userInfo");
const userId = JSON.parse(userInfo).userId;
onMounted(() => {
  getRoleMen();

  // 设置菜单权限时同步更新
  $eventBus.on("synchronizationMen", () => {
    getRoleMen();
  });
});

let getRoleMen = () => {
  getRoleMenuByUserId(userId).then((res) => {
    if (res.code == 1) {
    
      if(res.data == null||res.data.length==0) {
        menulist.value = getTreeData([]);
      }else{
        menulist.value = getTreeData(res.data);
      }

    }else{
      menulist.value = getTreeData([]);
    }

    // 显示暂无权限
      const timera = setTimeout(() => {
        if (menulist.value.length == 0) {
          $eventBus.emit("limits_isShow", false);
        } else {
          $eventBus.emit("limits_isShow", true);
        }
        clearTimeout(timera);
      }, 500);
  });
};
const getTreeData = (data) => {
  for (var i = 0; i < data.length; i++) {
    if (data[i].children == null||data[i].children.length < 1) {
      // children若为空数组，则将children设为null
      data[i].children = null;
    } else {
      // children若不为空数组，则继续 递归调用 本方法
      getTreeData(data[i].children);
    }
  }
  return data;
};

const menulist = ref([
  // {
  //   component: "Live",
  //   menuName: "直播管理",
  //   menuParentId: "Live",
  //   path: "/wenxiang_Backstage/Live",
  //   children: [],
  // },
  // {
  //   component: "Recording_resources",
  //   menuName: "录播资源管理",
  //   menuParentId: "",
  //   path: "/wenxiang_Backstage/Recording_resources",
  //   children: [],
  // },
  // {
  //   component: "Course",
  //   menuName: "课程管理",
  //   menuParentId: "",
  //   path: "/wenxiang_Backstage/Course",
  //   children: [],
  // },
  // {
  //   component: "ClassSchedule",
  //   menuName: t('live.scheduleMent'),
  //   menuParentId: "",
  //   path: "/wenxiang_Backstage/ClassSchedule",
  //   children: [],
  // },
  // {
  //   component: "SeriesOfCourses",
  //   menuName: "系列课管理",
  //   menuParentId: "",
  //   path: "/wenxiang_Backstage/SeriesOfCourses",
  //   children: [],
  // },
  // {
  //   component: "6",
  //   menuName: "结对组管理",
  //   menuParentId: "",
  //   path: "/wenxiang_Backstage/pairingCourse",
  //   children: [],
  // },
  // {
  //   component: "RemoteInteraction",
  //   menuName: "远程互动",
  //   menuParentId: "",
  //   path: "/wenxiang_Backstage/RemoteInteraction",
  //   children: [],
  // },
  // {
  //   component: "TeachingAndResearch",
  //   menuName: "教研组管理",
  //   menuParentId: "",
  //   path: "/wenxiang_Backstage/TeachingAndResearch",
  //   children: [],
  // },
  // {
  //   component: "9",
  //   menuName: "教研活动管理",
  //   menuParentId: "",
  //   path: "/wenxiang_Backstage/CourseEvaluationSchedule",
  //   children: [],
  // },
  // {
  //   component: "FamousTeachers",
  //   menuName: "名师管理",
  //   menuParentId: "",
  //   path: "/wenxiang_Backstage/FamousTeachers",
  //   children: [],
  // },
  // {
  //   component: "10",
  //   menuName: "基础管理",
  //   menuParentId: "",
  //   path: "",
  //   children: [
  //     {
  //       component: "Platform",
  //       menuName: "平台管理",
  //       menuParentId: "",
  //       path: "/wenxiang_Backstage/Platform",
  //       children: [],
  //     },
  //     {
  //       component: "User",
  //       menuName: "用户管理",
  //       menuParentId: "",
  //       path: "/wenxiang_Backstage/User",
  //       children: [],
  //     },
  //     {
  //       component: "EquipmentManagement",
  //       menuName: "设备管理",
  //       menuParentId: "",
  //       path: "/wenxiang_Backstage/EquipmentManagement",
  //       children: [],
  //     },
  //     {
  //       component: "BehaviorAnalysis",
  //       menuName: "行为分析管理",
  //       menuParentId: "",
  //       path: "/wenxiang_Backstage/BehaviorAnalysis",
  //       children: [],
  //     },
  //     {
  //       component: "Notice",
  //       menuName: "公告管理",
  //       menuParentId: "",
  //       path: "/wenxiang_Backstage/Notice",
  //       children: [],
  //     },
  //   ],
  // },
]);

// 获取路由meta
const route = useRoute();
const routethen = computed(() => {
  return route.meta.affiliation_Left;
});

// 左侧菜单切换 清楚面包屑的浏览器会话存储
function menuchange(event) {
  resetSetItem("breadcrumb", JSON.stringify([]));
}

// 菜单收起
const emit = defineEmits(["debit"]);
const collapsed = ref(false);
const shouqi = debounce(changecollapsed, 300);
function changecollapsed() {
  collapsed.value = !collapsed.value;
  emit("debit", collapsed.value);
}

onUnmounted(() => {
  // 移除监听事件
  $eventBus.off("synchronizationMen");
  // console.log("组件实例被销毁了");
});
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
